import React, { useEffect, useState } from "react";

import DataGrid, { Column, Editing } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";

import api from "../../../services/api";
import { DataGridWrapper } from "../styles";

export default function AdminDoDontClassifications() {
  const [classificationSource, setClassificationSource] = useState();

  useEffect(() => {
    const classificationStore = new CustomStore({
      key: "id",
      loadMode: "raw",
      load: async () => {
        const response = await api.get("/api/classification");
        return response.data;
      },
      insert: async (data) => {
        await api.post("/api/classification", data);
      },
      update: async (id, data) => {
        await api.put(`/api/classification/${id}`, data);
      },
    });

    setClassificationSource(
      new DataSource({
        store: classificationStore,
        paginate: true,
        reshapeOnPush: true,
      })
    );
  }, []);

  return (
    <DataGridWrapper>
      <DataGrid
        height={550}
        dataSource={classificationSource}
        showBorders={false}
        key="id"
        onRowUpdating={(options) => {
          options.newData = { ...options.oldData, ...options.newData };
        }}
      >
        <Editing mode="row" allowAdding allowUpdating />
        <Column dataField="id" allowEditing={false} visible={false} />
        <Column dataField="description" />
        <Column dataField="icon" />
        <Column dataField="isActive" dataType="boolean" />
      </DataGrid>
    </DataGridWrapper>
  );
}
